import isEmpty from "../helpers/is-empty.js";

export default function scrollToForm(gsap) {
    const linksToForm = Array.from(document.querySelectorAll(".primary-button-internal"));
    const scrollMargin = document.querySelector(".main-header").clientHeight + 10;

    function scrollTo(event) {
        event.preventDefault();
        const sectionToScroll = document.querySelector(this.hash);
       

        if ( document.querySelector(this.hash)) {
            gsap.to(window, {
                duration: 1.5,
                scrollTo: { y: sectionToScroll, offsetY: scrollMargin },
                ease: "power4.out",
            });
        }
    }

    if (!isEmpty(linksToForm)) {
        linksToForm.forEach((link) => {
            //const sectionToScroll = document.querySelector(link.hash);

            link.addEventListener("click", scrollTo, true);
        });
    }
}
